export default __webpack_public_path__ + "static/broadcastImg1-22060adb511326ad7979a4525b1d935b.webp";